import React from 'react';
import './App.css';
import RoutesComponent from './routes';
import { useVersionCheck } from './hooks/useVersionCheck';

const App = () => {
  useVersionCheck();

  return (
    <div className='App'>
      <RoutesComponent />
    </div>
  );
}

export default App;
